var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCategories(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#122442",
    d: "M15.445 2h-4.583c-.272 0-.492.22-.492.492v4.586c0 .272.22.493.492.493h1.806l.024 3.133H7.568V8.906c0-.272-.22-.492-.492-.492H2.49c-.27 0-.49.22-.49.492v4.583c0 .272.22.493.49.493h4.586c.272 0 .492-.22.492-.493v-1.798H12.7l.046 5.819H10.07v-1.804c0-.272-.22-.492-.492-.492H4.992c-.272 0-.492.22-.492.492v4.586c0 .272.22.492.492.492h4.586c.272 0 .492-.22.492-.492V18.49h3.175c.272 0 .49-.223.487-.492l-.05-3.806h2.35v1.8c0 .273.22.493.493.493h4.583c.272 0 .492-.22.492-.492v-4.583c0-.272-.22-.495-.492-.495h-4.583c-.272 0-.492.223-.492.495v1.797h-2.359l-.024-5.635h1.795c.272 0 .492-.22.492-.493V2.492c0-.272-.22-.492-.492-.492z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCategories);
export default __webpack_public_path__ + "static/media/icon-categories.4c90172a.svg";
export { ForwardRef as ReactComponent };